var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"error","block":"","loading":_vm.disabledLoading === true ? false : _vm.isLoading || _vm.$store.getters.isLoading,"disabled":!_vm.valid,"rounded":"","large":""},on:{"click":function($event){return _vm.$emit('click', false)}}},[_c('span',{staticClass:"btn",domProps:{"textContent":_vm._s(_vm.$t(_vm.title))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }